import { render } from "./TeacherQuestionManageView.vue?vue&type=template&id=07370a78&scoped=true"
import script from "./TeacherQuestionManageView.vue?vue&type=script&lang=js"
export * from "./TeacherQuestionManageView.vue?vue&type=script&lang=js"

import "./TeacherQuestionManageView.vue?vue&type=style&index=0&id=07370a78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07370a78"]])

export default __exports__